import React from "react";
import { useNavigate } from "react-router-dom";
import AdminShell from "@/pages/admin/AdminShell";
import { AlertsBoard } from "@/components/NextBestAction";

export default function AlertsPage() {
  const navigate = useNavigate();
  const onNavigate = (key) => {
    const map = { leads: "/leads", payments: "/payments", progress: "/villas", tasks: "/tasks", dataroom: "/documents" };
    navigate(map[key] || "/alerts");
  };
  return (
    <AdminShell>
      <AlertsBoard onNavigate={onNavigate} />
    </AdminShell>
  );
}
